<template>
  <div
    class="modal fade font-primary"
    :id="Id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg border-3 border-red-600 rounded-xl" role="document">
      <div class="modal-content">
        <div v-if="texto" class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{texto}}</h5>
        </div>
        <div class="modal-body py-0 bg-white" :class="{'mt-2 mb-2': !texto}">
          <div id="myCarouselNoticias" data-ride="carousel" class="carousel slide">
                <!-- Slides -->
                <div class="carousel-inner">
                  <div
                    v-for="(item, index) in carouselActivo"
                    :key="index"
                    class="w-full h-full"
                    :class="{
                      'carousel-item': true,
                      active: index === 0,
                    }"
                  >
                    <div v-if="!item.imagen || !item.imagen.split('|')[0]" class="flex justify-center">
                      <img
                        class="d-block w-100 max-h-[500px] object-contain"
                        src="../assets/no-photo.jpg"
                        alt="Imagen del articulo"
                      />
                    </div>
                    <div v-else
                    class="">
                      <img
                        v-if="isImage(item.imagen)"
                        :src="item.imagen.split('|')[0]"
                        :alt="'Slide ' + (index + 1)"
                        class="d-block w-100 max-h-[500px] object-contain"
                      />
                      <video
                        v-else
                        controls
                        class="d-block w-100 max-h-[500px] object-contain"
                      >
                        <source :src="item.imagen.split('|')[0]" type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                    <div v-if="item.aux" class="border-black border-t w-full p-2 flex items-center justify-center">
                      <p class="font-primary font-bold">{{ item.aux }}</p>
                    </div>
                  </div>
                </div>

              </div>
              <!-- Controls -->
              <a
                  class="carousel-control-prev h-2/4 mt-[13%]"
                  href="#myCarouselNoticias"
                  role="button"
                  data-bs-slide="prev"
                >
                  <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="visually-hidden">Previous</span>
                </a>
                <a
                  class="carousel-control-next h-2/4 mt-[13%]"
                  href="#myCarouselNoticias"
                  role="button"
                  data-bs-slide="next"
                >
                  <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="visually-hidden">Next</span>
                </a>
        </div>
        <div v-if="texto" class="modal-footer">
          <h5 class="modal-title" id="exampleModalLabel"></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carouselService from '@/services/carousel.service';
import configService from '@/services/config.service';
export default {
  name: "Carousel",
  props: {
    id: String,
  },
  data() {
    return {
      Id: this.id,
      show: true,
      carousel: [],
      texto: ''
    };
  },
  computed: {
    carouselActivo() {
      return this.carousel.filter(x => x.aux2)
    }
  },
  methods: {
    closeAlert() {
      this.show = false;
    },
    cargarCarousel() {
      this.getCarousel()
    },
    getCarousel() {
      configService.getCarouselTexto()
      .then((res) => {
        this.texto = res.data
      })
      .catch((err) => {
        console.log(err)
      })
      carouselService.getCarousel()
      .then((res) => {
        this.carousel = res.data
          this.carousel.forEach(x => {
            x.aux2 = (x.aux2 == 1)
            x.aux = (x.aux ? x.aux : '')
          })
          this.cargarFotosCarousel()
        })
          .catch((err) => {
            console.log(err)
          })
      },
      cargarFotosCarousel() {
        for (var i = 1; i < 11; i++ ) {
          this.getFotos(i)
        }
      },
      isImage(url) {
        return url && url.endsWith("image");
      },
      getFotos(i) {
        carouselService.getFotos(i)
          .then(res => {
            const contentType = res.headers["content-type"];

            if (
              contentType && (contentType.startsWith("image/") || contentType.startsWith("video/"))) {
              const mediaBlob = new Blob([res.data], { type: contentType });
              const mediaObjectURL = URL.createObjectURL(mediaBlob);
              const blobUrlWithExtension = `${mediaObjectURL}|${
                contentType.startsWith("image/") ? "image" : "video"
              }`;
                this.carousel[i - 1].imagen = blobUrlWithExtension
            } else {
                this.carousel[i - 1].imagen = ('|' + i);
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
  },
  mounted() {
    this.cargarCarousel()
  },
};
</script>
